export function youtubeSrc (id) {
	const params = new URLSearchParams({
		autoplay: '1',
		rel: '0',
		enablejsapi: '1',
		origin: window.location.origin,
	});
	return 'https://www.youtube-nocookie.com/embed/' + id + '?' + params.toString();
}

export function stopPlayingYoutube (except) {
	document.querySelectorAll('iframe').forEach((frame) => {
		if (frame === except) return;
		let url;
		try {
			url = new URL(frame.src || '', window.location.href);
		} catch (error) {
			return;
		}
		if (! /(^|\.)youtube(-nocookie)?\.com$/.test(url.hostname)) return;
		if (! url.pathname.startsWith('/embed/')) return;
		frame.contentWindow?.postMessage(JSON.stringify({
			event: 'command',
			func: 'stopVideo',
			args: [],
		}), '*');
	});
}
